import React, { memo } from 'react'

import Text from './Text'

const DefaultText = ({ sx, ...restProps }) => {
  return (
    <Text
      variant='body1'
      color='text.primary'
      component='div'
      sx={{ mt: 1, mb: 2, ...sx }}
      {...restProps}
    />
  )
}

export default memo(DefaultText)
